module.exports = __webpack_public_path__ + "static/media/sqbPyramid.38b80b34.jpg";